module.exports = __webpack_public_path__ + "static/media/533GriffinStNW_2018-06-05_17.d7f3b71e.jpg";